import React from "react";
import { Link } from "react-router-dom";
import "../FAQ/faq.scss";

const FAQ = () => {
  return (
    <div className="faq-main">
      <div className="common-banner">
        <div className="container">
          <div className="common-head">
            <div className="line-head">
              <p>Have Questions Ask Now</p>
            </div>
            <h1>FAQ</h1>
          </div>
          {/* <p className="text-center">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod Ut enim ad minim veniam. Lorem ipsum dolor sit amet
            adipisicing.
          </p> */}
        </div>
      </div>

      <div className="container">
        {/* <div className="faq-desc">
          <h5 className="sub-heading mb-4">Frequently Asked questions</h5>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum dolor
            sit amet, consectetur adipisicing elit, sed do eiusmod Ut enim ad.
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consectetur
            adipisicing elit, sed do eiusmod Ut enim ad. Lorem ipsum dolor sit
            amet. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
            do eiusmod Ut enim ad. Lorem ipsum dolor sit amet.
          </p>
        </div> */}

        <div id="accordion">
          <div className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              href="#collapseone"
            >
              What is InTransit?
              <span>
                <i class="fas fa-caret-down"></i>
              </span>
            </div>
            <div
              id="collapseone"
              className="collapse show"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  InTransit is a post-shopping solution that helps secure your
                  online orders from all your eCommerce retailers and merchants.
                  You can easily track your package from anywhere, anytime with
                  its cutting-edge live tracking feature and even get instant
                  query resolution for any of your order issues.
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              href="#collapsetwo"
            >
              What information do I need to share with InTransit, and what would
              they do with it?
              <span>
                <i class="fas fa-caret-down"></i>
              </span>
            </div>
            <div id="collapsetwo" className="collapse" data-parent="#accordion">
              <div className="card-body">
                <p>
                  In order to provide effective tracking services, InTransit
                  uses your order information like tracking numbers, carrier
                  names, and product information. This data helps us determine
                  the exact directives to manage the delivery. However, we
                  ensure complete data protection by integrating multiple
                  security layers and protocols to protect and secure customer
                  data.
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              href="#collapsethree"
            >
              What is the procedure to file a claim in case a package misplaced
              or lost?
              <span>
                <i class="fas fa-caret-down"></i>
              </span>
            </div>
            <div
              id="collapsethree"
              className="collapse"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  Click here! <Link to="/file-claim">(File a Claim)</Link>
                </p>
                <p>
                  Note: We refund the cost of the item(s) alone. Shipping costs,
                  taxes, and the Route premium are not included. We also do not
                  pay custom/duty fees.
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              href="#collapsefour"
            >
              How can I track my deliveries on InTransit?
              <span>
                <i class="fas fa-caret-down"></i>
              </span>
            </div>
            <div
              id="collapsefour"
              className="collapse"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  InTransit employs advanced Geo-fencing technology to offer
                  real-time packages tracking services.
                </p>
                <p>
                  In the tracking section, you get an easy-to-use mapping
                  interface to see your package's live location. A specific card
                  denotes each package, and you can tap on it to open up the
                  Order Details page. You can also select your package from the
                  package list displayed on the Orders screen and tap on it to
                  see the order details with its live location.
                </p>
              </div>
            </div>
          </div>

          <div className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              href="#collapsefive"
            >
              How can InTransit add more value to my post-shopping experience?
              <span>
                <i class="fas fa-caret-down"></i>
              </span>
            </div>
            <div
              id="collapsefive"
              className="collapse"
              data-parent="#accordion"
            >
              <div className="card-body">
                <p>
                  InTransit is here to take away all the hassle related to
                  package deliveries. You get leading-edge live tracking,
                  coupled with complete security and package protection in case
                  it gets lost, misplaced or damaged. All this for an affordable
                  price which might be quite negligible when compared to the
                  actual cost of the package.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="card">
            <div
              className="card-header"
              data-toggle="collapse"
              href="#collapsesix"
            >
              Loren ipsum dolor sit amet, consectetur elit, sed do eiusmod ut
              ad?
              <span>
                <i class="fas fa-caret-down"></i>
              </span>
            </div>
            <div id="collapsesix" className="collapse" data-parent="#accordion">
              <div className="card-body">
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum
                  dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                  Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
                  amet, consectetur adipisicing elit, sed do eiusmod Ut enim ad.
                  Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
                  consectetur adipisicing elit, sed do eiusmod Ut enim ad. Lorem
                  ipsum dolor sit amet. Lorem ipsum dolor sit amet, consectetur
                  adipisicing elit, sed do eiusmod Ut enim ad. Lorem ipsum dolor
                  sit amet.
                </p>
                <p>
                  {" "}
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed
                  do eiusmod Ut enim ad. Lorem ipsum dolor sit amet. Lorem ipsum
                  dolor sit amet, consectetur adipisicing elit.
                </p>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
